import React from 'react';
import { Check, X } from 'react-feather';

import { Text, TEXT_VARIANTS } from 'ui/Typography';

import Fade from 'components/shared/animated/Fade';

const Label = ({ id, error, success }) => {
  if (error) {
    return (
      <Text
        id={id}
        aria-live="polite"
        className="d-f ai-c ml-8"
        variant={TEXT_VARIANTS.INSTRUX_ERROR}
      >
        <X /> {t('settings.autosubmit.error')}
      </Text>
    );
  }

  if (success) {
    return (
      <Text
        id={id}
        aria-live="polite"
        className="d-f ai-c ml-8"
        variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD_SUCCESS}
      >
        <Check />
        {t('settings.autosubmit.saved')}
      </Text>
    );
  }

  return null;
};

const StatusLabel = ({ id, error, success }) => {
  return (
    <Fade in={error || success}>
      <>
        <Label id={id} error={error} success={success} />
      </>
    </Fade>
  );
};

export default StatusLabel;
